import React from 'react'
import { api } from '@/lib/api'

export default function ProfileEmailChange() {
  const [email, setEmail] = React.useState('')
  const [msg, setMsg] = React.useState<string | null>(null)
  const [err, setErr] = React.useState<string | null>(null)
  const [submitting, setSubmitting] = React.useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr(null); setMsg(null)

    if (!email) { setErr('Email is required.'); return }

    try {
      setSubmitting(true)
      const r:any = await api.post('/xapi/profile/email/change', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email })
      })
      setMsg(r.message || 'If possible, a verification link has been sent.')
    } catch (e:any) {
      setErr(e.message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div>
      <h1 style={{ fontSize:24, fontWeight:700, marginBottom:16 }}>Change email</h1>
      {msg && <div style={{ background:'#dcfce7', padding:10, borderRadius:8, marginBottom:10 }}>{msg}</div>}
      {err && <div style={{ background:'#fee2e2', padding:10, borderRadius:8, marginBottom:10 }}>{err}</div>}
      <form onSubmit={submit} style={{ display:'grid', gap:12, maxWidth:420 }}>
        <label>New email <input value={email} onChange={e=>setEmail(e.target.value)} /></label>
        <button type="submit" disabled={submitting}>{submitting ? 'Sending…' : 'Send verification link'}</button>
      </form>
    </div>
  )
}
